import { render } from "./ReporteGastosView.vue?vue&type=template&id=64dcc2f1&scoped=true"
import script from "./ReporteGastosView.vue?vue&type=script&lang=js"
export * from "./ReporteGastosView.vue?vue&type=script&lang=js"

import "./ReporteGastosView.vue?vue&type=style&index=0&id=64dcc2f1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64dcc2f1"]])

export default __exports__